import { render, staticRenderFns } from "./CorpPolityMenu.vue?vue&type=template&id=5e5bb8b8"
import script from "./CorpPolityMenu.vue?vue&type=script&lang=js"
export * from "./CorpPolityMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports